var checkExist = setInterval(function() {
   if ($('.spf-product-card').length) {
     jQuery('.spf-product-card a').each(function(){
      var hello = this.href;
      var remo = hello.substring(hello.indexOf("/products") + 0);
		jQuery(this).attr("href", remo);
    });
      console.log("Exists!");
      clearInterval(checkExist);
   }
}, 100);